import { render, staticRenderFns } from "./ComercialIcon.vue?vue&type=template&id=276eae20&"
import script from "./ComercialIcon.vue?vue&type=script&lang=ts&"
export * from "./ComercialIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports